module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm.$breakpoints.md || _vm.$breakpoints.lg || _vm.$breakpoints.lgUp) && _vm.user) ? _c('div', {
    staticClass: "profile-toolbar",
    attrs: {
      "context": "Profile Toolbar"
    }
  }, [(_vm.guest) ? [_c('ul', {
    staticClass: "member-login"
  }, [_c('li', [_c('sk-button', {
    attrs: {
      "small": "",
      "tag": "a",
      "href": "/user/signup",
      "tertiary": ""
    }
  }, [_vm._v("Create a profile")])], 1), _vm._v(" "), _c('li', [_c('sk-button', {
    attrs: {
      "small": "",
      "tag": "a",
      "href": "/user/login",
      "secondary": ""
    }
  }, [_vm._v("Sign in")])], 1)])] : [_c('div', {
    staticClass: "member-login"
  }, [(_vm.user.MemberLevelId != 19 && _vm.$breakpoints.lgUp) ? _c('span', {
    staticClass: "points-balance"
  }, [((_vm.$breakpoints.xs || _vm.$breakpoints.sm)) ? _c('h5', {
    staticClass: "points-balance__name"
  }, [_vm._v(_vm._s(_vm.user.FullName))]) : _vm._e(), _vm._v(" "), (_vm.$breakpoints.lgUp) ? [_c('span', {
    staticClass: "points"
  }, [_vm._v(_vm._s(_vm.user.PointsBalance))]), _vm._v(" POINTS\n            ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), ((_vm.$breakpoints.md || _vm.$breakpoints.lg || _vm.$breakpoints.lgUp)) ? [_c('sk-accordian', {
    attrs: {
      "select": "true",
      "active": _vm.active,
      "click-outside": "true"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('div', [_vm._v(_vm._s(_vm.user.FullName))])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('ul', {
    staticClass: "profile-items"
  }, [(_vm.$breakpoints.mdDown) ? _c('li', {
    staticClass: "points-balance in-dropdown"
  }, [_c('span', {
    staticClass: "points"
  }, [_vm._v(_vm._s(_vm.user.PointsBalance))]), _vm._v(" POINTS\n                    ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('sk-button', {
    attrs: {
      "link": "",
      "tag": "a",
      "to": "/user/profile"
    }
  }, [_vm._v("My Dashboard")])], 1), _vm._v(" "), _c('li', [_c('sk-button', {
    attrs: {
      "link": "",
      "tag": "a"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.signOut()
      }
    }
  }, [_vm._v("Sign Out")])], 1)])])], 2)] : _vm._e()], 2)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c430c6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/profile-toolbar/profile-toolbar.vue
// module id = 889
// module chunks = 0